import styled from 'styled-components';

export const Wrapper = styled.div<{ parentWidth?: number }>`
  display: grid;
  gap: 8px;
  width: 100%;

  ${({ parentWidth }) => {
    if (!parentWidth) {
      return '';
    }
    if (parentWidth >= 1348) {
      return `grid-template-columns: 1fr 1fr 1fr 1fr 1fr;`;
    }
    if (parentWidth >= 1080) {
      return `grid-template-columns: 1fr 1fr 1fr 1fr;`;
    }
    if (parentWidth >= 812) {
      return `grid-template-columns: 1fr 1fr 1fr;`;
    }
    if (parentWidth >= 544) {
      return `grid-template-columns: 1fr 1fr;`;
    }
    return 'grid-template-columns: 1fr 1fr;';
  }}
`;
